import { isPlainObject } from "lodash";

/**
 * Các field chỉ tồn tại ở query detail (GET_DETAIL_PROMOTION_CAMPAIGN), không có trong PromotionCampaignInput.
 * Khi clone/edit, form value được set thẳng từ data detail nên các field này bị gửi kèm lên mutation
 * và server trả về lỗi GRAPHQL_VALIDATION_FAILED: "unknown field".
 */
const NOT_INPUT_FIELDS = ["__typename", "sellerUserSegment"];

/**
 * Loại bỏ đệ quy các field không thuộc input schema khỏi params gửi lên
 * CreatePromotionCampaign/UpdateCampaign. Chỉ duyệt vào plain object và array
 * để không phá vỡ các giá trị đặc biệt (File, moment, Date...).
 */
export const sanitizePromotionCampaignInput = (value) => {
  if (Array.isArray(value)) {
    return value.map(sanitizePromotionCampaignInput);
  }

  if (isPlainObject(value)) {
    return Object.keys(value).reduce((acc, key) => {
      if (NOT_INPUT_FIELDS.includes(key)) {
        return acc;
      }
      acc[key] = sanitizePromotionCampaignInput(value[key]);
      return acc;
    }, {});
  }

  return value;
};
